var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4DB54B",
    d: "M10 0C4.484 0 0 4.484 0 10s4.484 10 10 10 10-4.484 10-10S15.516 0 10 0zm5.495 13.705c-.19.463-.527.927-.737 1.137-1.2 1.2-4.421.126-7.074-2.526-2.652-2.653-3.726-5.853-2.526-7.074.21-.21.695-.547 1.137-.737.337-.147.737-.042.968.253L8.59 6.442c.274.337.232.842-.105 1.137-.337.295-.568.505-.631.568-.506.506.231 1.58 1.347 2.695 1.116 1.116 2.168 1.874 2.695 1.348.063-.064.273-.295.568-.632.295-.337.78-.38 1.137-.105l1.684 1.326c.274.168.358.568.21.926z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phoneCall.f42e5c5299195a391563aa4ee4ea687f.svg";
export { ForwardRef as ReactComponent };